// extracted by mini-css-extract-plugin
export var isClosed = "burger-module--isClosed--bc58c";
export var isOpened = "burger-module--isOpened--07ed2";
export var isScrolled = "burger-module--isScrolled--868ef";
export var menu = "burger-module--menu--d2154";